<button role="button" class="multi-select" [ngClass]="{'active': hasSelectedOptions}" (click)="openSelect()" #mainEl>
  <span class="multi-select__icon"><brt-icon [icon]="icon" *ngIf="icon"></brt-icon></span>
  <div class="multi-select__title">
    {{label}}
  </div>

  <span class="multi-select__selected-options-number">{{numberLabel ?? selectedOptionsNumber}}</span>
  <span class="multi-select__dropdown-icon"><brt-icon [icon]="'dropdown'"></brt-icon></span>


<!--  <li *ngFor="let option of options" class="multi-select__option" [ngClass]="{'multi-select__option&#45;&#45;selected' : option.selected}" (click)="toggleOption(option)">-->
<!--    {{option.label}} <span *ngIf="option.selected">X</span>-->
<!--  </li>-->
</button>
